import { logWrapper } from '../utils';

export default {
  configurationModel: [
    'runtimeConstant',
    function (runtimeConstant) {
      function Configuration(data, hasDocs) {
        this.id = data.Id;
        this.idCompany = data.IdCompany;
        this.isDescriptionRevisionRequired = data.IsDescriptionRevisionRequired;
        this.deleteFiles = data.DeleteFiles;
        this.codeFormat = data.CodeFormat;
        this.isWorkflowOptional = data.IsWorkflowOptional;
        this.value0 = data.Value0;
        this.value1 = data.Value1;
        this.value2 = data.Value2;
        this.value3 = data.Value3;
        this.value4 = data.Value4;
        this.value5 = data.Value5;
        this.ReplaceGenerateNewRevision = data.ReplaceGenerateNewRevision;
        this.signPdfAsP7s = data.SignPdfAsP7S;
        this.showOnlyApprovedRevisions = data.ShowOnlyApprovedRevisions;
        this.hasDocuments = hasDocs;
        this.phoneForSupport = data.PhoneForSupport;
      }

      function run() {
        try {
          Configuration.prototype = {};
          return Configuration;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
